import { unref } from 'vue';
import { useStore } from 'vuex';

export function usePanelEstimationResults(options = {}) {
  const store = options.store || useStore();

  function getTotalPanels(wallTypes) {
    let total = 0;

    wallTypes.forEach(wallType => {
      wallType.panels.forEach(panel => {
        if (panel.selectedOption === 3) {
          const roundedRatio = Math.ceil(panel.ratio * 100) / 100;
          const wholeNumber = Math.floor(roundedRatio);

          if (roundedRatio === wholeNumber) {
            total += wholeNumber;
          }
        } else {
          total += Math.floor(panel.ratio);
        }
      });
    });

    return total;
  }

  function buildPanelEstimationResults({
    wallTypes,
    pannelPortions,
    shipmentTrucks,
    debouncedTruckLength,
    debouncedTruckWidth,
    debouncedTruckHeight,
    debouncedSpacerThickness,
  }) {
    return {
      completePanels: getTotalPanels(unref(wallTypes)),
      irregularPanels: unref(pannelPortions)?.length ?? 0,
      numberOfTrucks: unref(shipmentTrucks)?.length ?? 0,
      truckDimensions: {
        length: Number(unref(debouncedTruckLength)),
        width: Number(unref(debouncedTruckWidth)),
        height: Number(unref(debouncedTruckHeight)),
      },
      spacerThickness: Number(unref(debouncedSpacerThickness)),
    };
  }

  function savePanelEstimationResults(panelEstimationInputs) {
    const panelEstimationResults = buildPanelEstimationResults(panelEstimationInputs);
    return store.dispatch('savePanelEstimationData', panelEstimationResults);
  }

  return {
    getTotalPanels,
    buildPanelEstimationResults,
    savePanelEstimationResults,
  };
}